import {
  NavigationGuardNext,
  RouteLocationNormalized,
  Router
} from "vue-router";
import { User } from "../../domain/entities/entities";
import store from "../../infrastructure/repository/store/store";

/** Makes a request to a private route and if is unauthorized redirect to home. */
export const handleAccess = async (to, from, next): Promise<void> => {
  try {
    await store.dispatch("userProfile_module/validateUserIsLogged");
    next();
  } catch (e) {
    console.log(e);
    if (e?.response?.status === 403)
      return next({
        name: "home",
        query: {
          redirect: to.fullPath
        }
      });
    return next();
  }
};

/** It does verify if routeTo is "dashboard" and if user is logged first time, if true will redirect to onboarding else dashboard.
 * @param routeTo It refers the route that user is trying to access. */
async function handleOnBoardingRedirect(
  routeTo: RouteLocationNormalized,
  router: Router
) {
  if (routeTo.name === "dashboard") {
    const { isFirstLogin } = (await store.getters[
      "userProfile_module/user"
    ]) as User;
    if (isFirstLogin) {
      await router.push({ name: "onboarding", params: { step: 1 } });
    }
  }
}

export async function handleUserAuthRedirect(
  routeTo: RouteLocationNormalized,
  routeFrom: RouteLocationNormalized,
  next: NavigationGuardNext,
  router: Router
) {
  const isUserLogged = await store.getters["userProfile_module/user"];
  /** It doesn't let user access any route if isn't logged and route isn't public*/
  if (!routeTo.meta.isPublic && !isUserLogged) {
    return next({
      name: "home",
      query: {
        redirect: routeTo.fullPath
      }
    });
  }

  /** It will call onBoardingRedirect if route is private and user is already logged in */
  if (!routeTo.meta.isPublic) {
    await handleOnBoardingRedirect(routeTo, router);
  }

  next();
}
